import { useEvidencePermission } from '@utils/permission-hook';
import React from 'react';
import { useIntl } from 'react-intl';
import { AuthoredEvidence, Evidence } from '@eas/common-web';
import { IpEntry } from '@models';
import { Fields } from './ip-entry-fields';
import { useColumns } from './ip-entry-columns';
import { EvidenceApiUrl, ExportTag, Permission } from '@enums';
import { useValidationSchema } from './ip-entry-schema';

export function IpEntries() {
  const intl = useIntl();

  const validationSchema = useValidationSchema();

  const permissions = useEvidencePermission({
    options: {
      NEW: [Permission.Default.ADMINISTRATOR],
      EDIT: [Permission.Default.ADMINISTRATOR],
      REMOVE: [Permission.Default.ADMINISTRATOR],
      REFRESH: [Permission.Default.ADMINISTRATOR],
      SHARE: [Permission.Default.ADMINISTRATOR],
      CHECK: [Permission.Default.ADMINISTRATOR],
      SAVE: [Permission.Default.ADMINISTRATOR],
      CLOSE: [Permission.Default.ADMINISTRATOR],
    },
  });

  const evidence = AuthoredEvidence.useAuthoredEvidence<IpEntry>({
    version: 1,
    identifier: 'IP_ENTRIES',
    apiProps: {
      url: EvidenceApiUrl.IP_ENTRY,
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'TAPIS__IP_ENTRIES__TABLE__TITLE',
        defaultMessage: 'Správa blokací IP Adres',
      }),
      reportTag: ExportTag.IP_ENTRY_GRID,
    },
    detailProps: {
      FieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'TAPIS__IP_ENTRIES__DETAIL__TITLE',
          defaultMessage: 'Správa blokací IP Adres',
        }),
        showBtn: permissions,
      },
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
